import { bridge } from '../../../bridge';
import { useCallback } from 'react';

/**
 * - 검색 페이지로 이동
 */
export const useMoveToSearch = () => {
  return useCallback(() => {
    bridge.openPath('/search');
  }, []);
};
